import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames/bind';

import NewTag from '../../../Shared/NewTag';
import BetaTag from '../../../Shared/BetaTag';
import DcscPoweredBy from '../../../Shared/DcscPoweredBy';

import withComponentName from '../../../../decorators/withComponentName';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);
export const DirectoryTab = ({
  tab: {
    name,
    path,
    icon,
    disabled,
    isBeta,
    isNew,
    isForPremiumPage,
    checkAccess,
  },
  permissions,
}) => {
  const isDisabled = checkAccess ? !(permissions?.features || []).includes(checkAccess) : false;

  return (
    <div className={Styles.tab} aria-disabled={disabled || isDisabled}>
      {(disabled || isDisabled) && <div className={Styles['coming-soon-badge']}>Coming soon</div>}
      <Link to={path}>
        <div className={Styles.icon}>
          {!icon.fontIcon ? (
            <img
              src={icon.src}
              width={icon.width}
              height={icon.height}
              alt="Directory"
            />
          ) : (
            <FontAwesomeIcon icon={icon.fontIcon} />
          )}
        </div>
        {(isBeta || isNew) && (
          <div className={Styles.beta_holder}>
            {isBeta && <BetaTag className={cx('beta_tag_custom')} />}
            {isNew && <NewTag className={cx('new_tag_custom', { isPremiumPage: isForPremiumPage })} />}
          </div>
        )}
        <div className={Styles.name}>{name}</div>
        {name === 'sectors' && (
          <DcscPoweredBy />
        )}
      </Link>
    </div>
  );
};

DirectoryTab.propTypes = {
  tab: PropTypes.shape({
    name: PropTypes.string,
    path: PropTypes.string,
    reload: PropTypes.bool,
    icon: PropTypes.shape({
      src: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number,
    }),
    disabled: PropTypes.bool,
    isBeta: PropTypes.bool,
  }).isRequired,
};

export default withComponentName(DirectoryTab);
